import { doNotModifyCodeBelow } from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultMiddleCode = `// TODO: This lesson won't compile... Can you make it compile?
`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
